const faqs = [
  {
    q: '什么是下拉式漫画阅读？和普通翻页有什么区别？',
    a: '下拉式漫画阅读是一种创新的浏览方式，漫画内容按纵向排列，读者只需向下滑动即可连续阅读，无需点击翻页按钮。相比传统翻页模式，下拉式阅读消除了翻页等待和视觉割裂感，让漫画阅读像刷社交媒体一样流畅自然。亲亲漫画网所有作品均支持下拉式阅读，带给你沉浸式的追漫体验。',
  },
  {
    q: '亲亲漫画网真的完全免费吗？需要注册会员吗？',
    a: '亲亲漫画网承诺全站漫画永久免费，无需注册、无需充值、无需购买会员。我们坚持"好漫画应该被所有人看到"的理念，通过优化运营成本来维持平台运转，不向读者收取任何费用。你可以直接打开网站，搜索喜欢的漫画，即刻开始下拉式阅读，没有任何隐藏消费。',
  },
  {
    q: '漫画更新频率如何？能及时看到最新连载吗？',
    a: '亲亲漫画网每日追踪更新50+部热门连载漫画，覆盖日漫和韩漫的主流作品。我们的内容团队会在原作更新后第一时间同步上线，确保读者能在最短时间内通过下拉式阅读看到最新内容。热门连载通常在更新日当天即可在平台阅读，追更快人一步。',
  },
  {
    q: '移动端阅读体验怎么样？需要下载APP吗？',
    a: '亲亲漫画网采用响应式设计，完美适配手机、平板等移动设备，无需下载任何APP。在浏览器中打开网站即可享受流畅的下拉式漫画阅读体验。网站支持添加到手机桌面快捷方式，操作体验接近原生APP。我们特别优化了移动端的图片加载和滑动流畅度，小屏幕也能畅快看漫。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            关于亲亲漫画网下拉式阅读的常见疑问解答
          </p>
        </div>

        <div className="max-w-[800px] mx-auto space-y-4">
          {faqs.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="flex-shrink-0 w-7 h-7 flex items-center justify-center rounded-lg bg-primary-50 text-primary-500 text-sm font-bold mt-0.5">Q</span>
                <span>{item.q}</span>
              </h3>
              <div className="flex items-start gap-3 pl-10">
                <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}